/**
 * Generated class for the BusinessProductListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';

import { BusinessProductManagerHandler } from '../../providers/business-product-handler';
import { BusinessProductManagerPage } from '../business-product-manager/business-product-manager';

import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-business-product-list',
  templateUrl: 'business-product-list.html',
})
export class BusinessProductListPage {
	products: any;
	hasProducts: boolean = false;
	categories: any;
	filePath: any;
	loader: any;
	isLoading: boolean = false;

	loadingMsg: any = "Loading...";
	isRefreshing: boolean = false;
	lastRequestReturnedValues: boolean = false;

	params: any = {
		page: 1,
		size: 20,
		cb: null
	}

  	constructor(
  		public navCtrl: NavController, 
		public navParams: NavParams,
		public productManagerHandler: BusinessProductManagerHandler,
		public alertCtrl: AlertController,
		public loadingCtrl: LoadingController,
		public globals: Globals,
		) {
		this.filePath = this.globals.fileUrl;
  	}

  	ionViewWillEnter() {
		this.load(null);
	}	

	doRefresh(refresher) {
		this.isRefreshing = true;

		this.load(()=>{
			this.isRefreshing = false;
		  	refresher.complete();
		})
	}  	

	doInfinite(infiniteScroll){
		if(!this.lastRequestReturnedValues){
			infiniteScroll.complete();
			return;
		} 

		this.isRefreshing = true;

		this.params.page++;

		this.load(()=>{
			this.isRefreshing = false;
			
			infiniteScroll.complete();
		});
	}		

	createProduct(){
	    this.navCtrl.push(BusinessProductManagerPage, {
	      product: {},
	      categories: this.categories
	    });		
	}

	manageProduct($e, product){
	    this.navCtrl.push(BusinessProductManagerPage, {
	      product: product,
	      categories: this.categories
	    });				
	}

	load(cb){
		this.isLoading = (!this.isRefreshing) ? true : false;

		this.params.cb = (result)=>{

			for(let product of result.Products){
				product.Initial = product.ProductName.charAt(0)
			}

			this.products = result.Products;

			this.hasProducts = this.products.length>0;

			this.categories = result.Categories;

			this.isLoading = false;

			if(typeof cb == "function")
				cb()			
		}
		
		this.productManagerHandler.getProducts(this.params)
	}

}



// WEBPACK FOOTER //
// ./src/pages/business-product-list/business-product-list.ts